import { IPbrInputProps } from "../PbrInput/PbrInput";
import * as React from "react";
import { PbrInputMask } from "../PbrInput/PbrInputMask";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { useState } from "react";

export function PbrInputPhone(
    props: {
        formWrapper: WrappedFormUtils;
        isRequired?: boolean;
    } & IPbrInputProps
) {

    const [mask] = useState("(99) 9 9999-9999");

    return (
        <PbrInputMask
            type="tel"
            placeholder="Digite seu celular"
            name={props.name}
            mask={mask}
            maskChar={null}
            rules={[
                {
                    required: props.isRequired,
                    message: "Telefone é obrigatório!"
                }, {
                    validator: (rule, value, callback) => {
                        if (value) {
                            const phoneValidator = /^\([1-9]{2}\) 9 [0-9]{3,4}\-[0-9]{4}$/;
                            const isPhone = phoneValidator.exec(value);
                            if (isPhone) {
                                callback();
                            } else {
                                callback("Celular inválido.");
                            }
                        } else {
                            callback();
                        }
                    }
                }]} {...props} />
    );
}



// WEBPACK FOOTER //
// ./src/components/common/PbrInputPhone/PbrInputPhone.tsx